// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"594":"94dd1edb","953":"6526e042"}[chunkId] + ".js";
};